import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Button } from "@shadcn-in-nx/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@shadcn-in-nx/ui/alert-dialog";
import { useBluelagoon } from "@bluelagoon";
import { Loader2, Users, AlertCircle, CheckCircle } from "lucide-react";

export default function UserLimitBypassPanel({ companyId, companyName, currentBypass, onUpdated }) {
    const { t } = useTranslation();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const { call, isLoading } = useBluelagoon({ method: "setUserLimitBypass" });

    const nextValue = !currentBypass;

    const handleConfirm = async () => {
        setConfirmOpen(false);
        setSuccess(null);
        setError(null);
        try {
            const res = await call({ companyId, enabled: nextValue });
            if (res?.data) {
                setSuccess(res.data.message);
                onUpdated();
            }
        } catch (err) {
            setError(err?.error || t("userLimitBypass.failed"));
        }
    };

    return (
        <Card>
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2">
                    <Users className="h-5 w-5" />
                    {t("userLimitBypass.title")}
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
                <p className="text-sm text-muted-foreground">
                    {currentBypass ? t("userLimitBypass.descriptionOn") : t("userLimitBypass.descriptionOff")}
                </p>
                <Button onClick={() => setConfirmOpen(true)} disabled={isLoading} variant={currentBypass ? "destructive" : "default"}>
                    {isLoading && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}
                    {currentBypass ? t("userLimitBypass.disable") : t("userLimitBypass.enable")}
                </Button>
                {error && <div className="flex items-center gap-2 text-red-600 text-sm"><AlertCircle className="h-4 w-4" />{error}</div>}
                {success && <div className="flex items-center gap-2 text-green-600 text-sm"><CheckCircle className="h-4 w-4" />{success}</div>}

                <AlertDialog open={confirmOpen} onOpenChange={setConfirmOpen}>
                    <AlertDialogContent>
                        <AlertDialogHeader>
                            <AlertDialogTitle>
                                {nextValue ? t("userLimitBypass.confirmEnableTitle") : t("userLimitBypass.confirmDisableTitle")}
                            </AlertDialogTitle>
                            <AlertDialogDescription>
                                {nextValue ? t("userLimitBypass.confirmEnableBody", { companyName }) : t("userLimitBypass.confirmDisableBody", { companyName })}
                            </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                            <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
                            <AlertDialogAction onClick={handleConfirm}>{t("common.confirm")}</AlertDialogAction>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialog>
            </CardContent>
        </Card>
    );
}
